import React from "react"

const Prose = ({children}) => (
    <article className="prose prose-zinc prose-lg max-w-none prose-blue dark:prose-invert dark:prose-hr:border-zinc-600 dark:prose-tr:border-zinc-600">
        {children}
    </article>
)

export default Prose
